import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import React from "react";

import {
  sxFancyTableBorder,
  sxTableHeadBG
} from "../../theme/globalStyles";
import TimeFormat from "../../utils/timeFormat";

export default function NotificationTable({ allNotification }) {
  return (
    <TableContainer>
      <Table
        sx={{
          minWidth: 650,
          ...sxFancyTableBorder,
          td: {
            padding: "8px",
          },
        }}
        aria-label="simple table"
      >
        <TableHead sx={{ ...sxTableHeadBG }}>
          <TableRow>
            <TableCell align="center">SL</TableCell>
            <TableCell align="left">Title</TableCell>
            <TableCell align="left">Message</TableCell>
            <TableCell align="left">Type</TableCell>
            {/* <TableCell align="left">Read</TableCell> */}
            <TableCell align="left">Sender</TableCell>
            <TableCell align="left">Created At</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {allNotification?.map((row, index) => (
            <TableRow
              key={row.id}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell align="center">{index + 1}</TableCell>

              <TableCell align="left">{row.title}</TableCell>

              <TableCell align="left">{row.message}</TableCell>

              <TableCell align="left" sx={{ textTransform: "capitalize" }}>
                {row.type?.replace("_", " ").toLowerCase()}
              </TableCell>

              {/* <TableCell align="left">
                <Stack direction="row" gap={1} alignItems="center">
                  <div
                    style={{
                      height: "8px",
                      width: "8px",
                      borderRadius: "8px",
                      backgroundColor: row.read
                        ? activeIndicateColor
                        : inActiveIndicateColor,
                    }}
                  ></div>
                  {row.read ? "Yes" : "No"}
                </Stack>
              </TableCell> */}

              <TableCell align="left">{row.sender.name}</TableCell>

              <TableCell align="left">
                {TimeFormat(row.creationDateTimeStamp)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
